import { Accordion as AccordionType } from '@/types';
import Streamfields from '@streamfields/Streamfields';
import { ChevronDownIcon } from '@radix-ui/react-icons';
import clsx from 'clsx';

type Props = {
  className?: string;
  accordions: AccordionType[];
};

function Loading(props: Props) {
  const { className, accordions } = props;
  return (
    <div className={clsx('flow', className)}>
      {accordions.map(accordion => (
        <div className='accordion' key={accordion.title}>
          <h2 className='accordion__header'>
            <span className='accordion__trigger'>
              <ChevronDownIcon className='accordion__icon' />
              {accordion.title}
            </span>
          </h2>
          <div className='accordion__content' data-state='closed'>
            {accordion.content ? <Streamfields fields={accordion.content} /> : null}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Loading;
